import { lightDBHost } from "./utils"

export interface SquareAddress {
  address_line_1?: string
  address_line_2?: string
  locality?: string
  administrative_district_level_1?: string
  postal_code?: string
  country?: string
}

export interface SquareCustomer {
  id?: string
  given_name: string
  family_name: string
  email_address?: string
  address: SquareAddress
  phone_number?: string
  reference_id: string
  note: string
}

export interface SquareMoney {
  amount: number
  currency: "USD"
}

export interface SquareTransactionRequest {
  idempotency_key: string
  billing_address: SquareAddress
  amount_money: SquareMoney
  order_id: string
  card_nonce: string
  reference_id: string
  note: string
  customer_id: string
  delay_capture: boolean
}

export interface SquareTransactionResponse {
  transaction: {
    id: string
    location_id: string
    created_at: Date["toISOString"]
    tenders: [
      {
        id: string
        location_id: string
        transaction_id: string
        created_at: Date["toISOString"]
        note: string
        amount_money: {
          amount: number
          currency: string
        }
        processing_fee_money: {
          amount: number
          currency: string
        }
        customer_id: string
        type: string
        card_details: {
          status: string
          card: {
            card_brand: string
            last_4: string
            fingerprint: string
          }
          entry_method: string
        }
      }
    ]
    reference_id: string
    product: string
    order_id: string
  }
}

export interface SquareLineItemTax {
  catalog_object_id: string
}

export interface SquareLineItem {
  quantity: string
  note: string
  catalog_object_id: string
  taxes: SquareLineItemTax[]
}

export interface SquareOrder {
  idempotency_key: string
  reference_id: string
  line_items: SquareLineItem[]
  total_money?: SquareMoney
}

export interface SquareOrderResponse extends SquareOrder {
  id: string
}

export interface SquareCustomerCard {
  card_nonce: string
  cardholder_name: string
  billing_address: SquareAddress
}

export interface SquareCheckout {
  idempotency_key: string
  order: SquareOrder
  pre_populate_buyer_email?: boolean
  pre_populate_shipping_address?: boolean
  redirect_url?: string
  note?: string
}

export async function postSquareProxy(
  endPoint: string,
  postBody: any,
  method: string = "post",
  queryParams?: object
) {
  return fetch(`${lightDBHost()}/squareProxy`, {
    headers: {
      "Content-Type": "application/json"
    },
    method: "POST",
    mode: "cors",

    body: JSON.stringify({
      endPoint: endPoint,
      postBody: postBody,
      method: method,
      queryParams: queryParams
    })
  })
    .then(res => {
      if (res.status >= 400) {
        console.log(JSON.stringify(res.statusText))
        throw new Error(`Bad response from server ${res.statusText}`)
      }
      return res.json()
    })
    .then(json => {
      return json
    })
}

export async function loadAllSquareCustomers() {
  let customers: SquareCustomer[] = []
  let cursor = null
  while (customers.length === 0 || cursor) {
    const queryParams: object | undefined = cursor
      ? { cursor: cursor }
      : undefined
    const found: any = await postSquareProxy(
      "/customers",
      null,
      "get",
      queryParams
    )
    cursor = found.cursor
    customers = customers.concat(found.customers)
  }
  return customers
}
